import React from 'react';
import { Box, Typography } from '@mui/material';

interface TeamLogoProps {
    logo: string;
    title: string;
}

export default function TeamLogo({ logo, title }: TeamLogoProps) {
    return (
        <Box display="flex" flexDirection="row" alignItems="center" flex={1} minWidth={0}>
            <Box
                component="img"
                src={logo}
                alt={`${title} logo`}
                sx={{
                    height: 48,
                    width: 48,
                    borderRadius: '8px',
                    objectFit: 'cover',
                    flexShrink: 0,
                }}
            />
            <Typography
                variant="subtitle1"
                fontWeight={700}
                sx={{
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    marginLeft: 2,
                    display: '-webkit-box',
                    WebkitLineClamp: 2,
                    WebkitBoxOrient: 'vertical',
                }}
            >
                {title}
            </Typography>
        </Box>
    );
}
